import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

import RentalRepIconChecker from 'app/sm/rental_reputation/rental_rep_icon_checker'

interface ProfileItemsContainerProps {
  title: string
  message: string
  completeness: any
  profileItems: any
}

const RentalReputationItem = (
  key: any,
  icon: any,
  name: any,
  checked: any,
  url: any,
  attachmentSupportedSection: any,
  attachmentChecked: any,
) => (
  <Link
    key={key}
    className={checked ? 'bc-hub-item-link have-data' : 'bc-hub-item-link'}
    to={url}
  >
    <header>
      <i className={icon} />
      <span>{name}</span>
      <RentalRepIconChecker
        attachmentSupportedSection={attachmentSupportedSection}
        isCompleted={attachmentChecked}
        tooltipID={key}
      />
    </header>
  </Link>
)

const ProfileItemsContainer: React.FC<ProfileItemsContainerProps> = ({
  title,
  message,
  completeness,
  profileItems,
}) => (
  <div className="profile-item">
    {title && <h3>{title}</h3>}
    {message && <p className="mt10 mb30">{message}</p>}
    {profileItems.map((element: any) =>
      RentalReputationItem(
        element.key,
        element.icon,
        element.name,
        completeness[element.key],
        element.url,
        element.attachmentSupportedSection,
        completeness[element?.attachmentSupportedSectionKey],
      ),
    )}
  </div>
)

ProfileItemsContainer.propTypes = {
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  completeness: PropTypes.object.isRequired,
  profileItems: PropTypes.arrayOf(PropTypes.object).isRequired,
}

export default ProfileItemsContainer
